import { DateTime } from "luxon";
import ReactECharts from 'echarts-for-react';

export default function TimeAxis({shiftStart, shiftEnd, position}: {shiftStart: DateTime, shiftEnd: DateTime, position: "top" | "bottom"}) {
    let start = DateTime.local().set({hour: shiftStart.hour, minute: shiftStart.minute, second: 1, millisecond: 0}).toISO()
    let end = shiftStart.toSeconds() < shiftEnd.toSeconds() ? DateTime.local().set({hour: shiftEnd.hour, minute: shiftEnd.minute, second: 0, millisecond: 0}).toISO() : DateTime.local().plus(86400000).set({hour: shiftEnd.hour, minute: shiftEnd.minute, second: 0, millisecond: 0}).toISO()
    const options = {
      grid: {
        top: position === "top" ? -1 : -20,
        left: "24px",
        right: "24px",
        bottom: 0,
        height: "20px"
      },
      xAxis: {
        type: 'time',
        position: position,
        splitLine: {
          show: false,
        },
        axisLabel: {
          formatter: function (value: number) {
            return DateTime.fromMillis(value).toFormat("HH:mm");
          },
          inside: position === "top" ? true : false,
          margin: position === "top" ? 0 : 0,
          showMinLabel: true,
          showMaxLabel: true
        },
        splitNumber: shiftStart.diff(shiftEnd).hours,
        maxInterval: 3600 * 1000 * 24,
        minInterval: 3600,
      },
      yAxis: {
        show: false
      },
      series: [
        {
          type: 'line',
          showSymbol: false,
          data: [
            [start],
            [end],
          ], // data,
        },
      ],
    };
  
    return (
      <div className="flex-none h-8">
        <ReactECharts option={options} notMerge={true} style={{ height: 32, width: "100%" }} opts={{ renderer: "canvas" }}/>
      </div>
    );
  }